
import Vue from 'vue';
import { GetCustomerData } from '@root/modules/customer/types/customer';

interface Computed {
  isLoggedIn: boolean;
  getProfile: GetCustomerData | null;
}

interface Methods {
  logout: () => void;
  openLoginModal: () => void;
}

export default Vue.extend<unknown, Methods, Computed, unknown>({
  computed: {
    isLoggedIn() {
      return this.$instanceConnector('customer').state.isLoggedIn;
    },
    getProfile() {
      return this.$instanceConnector('customer').state.profile;
    },
  },
  methods: {
    logout() {
      this.$store.dispatch('customer/logout');
    },
    openLoginModal() {
      if (!this.isLoggedIn) {
        this.$store.commit('customer/setModalState', true);
      }
    },
  },
  render() {
    const { isLoggedIn, getProfile } = this;
    const data = {
      isLoggedIn,
      profile: getProfile,
    };

    return this.$scopedSlots.default!({
      data,
      logout: this.logout,
      openLoginModal: this.openLoginModal,
    }) as any;
  },
});
